import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate, Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { GetCacheKey } from "../../services/common/utils";
import MessageModal from "../common/bottom-modal-message";
import CardsComponent from "../common/cards";
import { Grid } from "swiper";
import { Pagination } from "react-bootstrap";
import { t } from "i18next";
import Loadingcomponent from "../loader/loadingcomponent";
import SwiperComponent from "../common/swipers"

const RecentTransactionswiperComponent = (pmsitem) => {
  const navigate = useNavigate()
  const [srvList, setSrvList] = useState([]);
  const recentTrasactionApi = useQuery(
    [
      GetCacheKey("HOME_DASHBOARD_URL_RECENT_TRANSACTION"),
      pmsitem?.pmsitem.method,
      JSON.parse(pmsitem?.pmsitem.sourceid),
      {},
    ],
    {
      retry: false,
      retryOnMount: true,
    }
  );
  
  useEffect(() => {
    if (recentTrasactionApi.isSuccess && recentTrasactionApi?.data?.data) {
      setSrvList(recentTrasactionApi?.data?.data?.response);
    }
  }, [recentTrasactionApi?.data?.data, recentTrasactionApi.isSuccess]);
  
  if (recentTrasactionApi?.isLoading || recentTrasactionApi?.isFetching) {
    return (
      <div class={`dls-sprint13-comp ${pmsitem?.pmsitem?.position === '15' ? 'recent_purchase_mt' : ''}`}>
      <div class="flex_grp_between mb-3">
          <h3 class="section_title_light mb-0 shimmerBG shimmer-card-title w-50 p-3"></h3>
          <a class="hyperlink shimmerBG shimmer-p-text p-2 w-25 m-0">
          </a>
      </div>
      <Swiper className="rect_card_swiper_1 mb-2"
              spaceBetween={12}
              pagination={false}
              slidesPerView={1.5}
              grid={{ rows: 1, fill: "row" }}>
          <SwiperSlide className="card_style_2 height_100">
                      <div class="card_img shimmerBG shimmer-icon-lg w-20">
                      </div>
                      <div class="card_info">
                          <div class="card_info_grp">
                              <h4 class="shimmerBG shimmer-h30 w-100"></h4>
                              <p class="shimmerBG shimmer-h40 w-100"></p>
                          </div>
                          <div class="card_link flex_grp_align_center  shimmerBG shimmer-text-sm w-20">
                              <a href="#" class="hyperlink"></a>
                          </div>
                      </div>
          </SwiperSlide>
          <SwiperSlide className="card_style_2 height_100">
                      <div class="card_img shimmerBG shimmer-icon-lg w-20">
                      </div>
                      <div class="card_info">
                          <div class="card_info_grp">
                              <h4 class="shimmerBG shimmer-h30 w-100"></h4>
                              <p class="shimmerBG shimmer-h40 w-100"></p>
                          </div>
                          <div class="card_link flex_grp_align_center  shimmerBG shimmer-text-sm w-20">
                              <a href="#" class="hyperlink"></a>
                          </div>
                      </div>
          </SwiperSlide>

      </Swiper>
  
  </div>
    );
}
  return (
    <>
   {(srvList?.length> 0 )?
   
//    <section class="dls-sprint13-comp pt-5 mb-4" >
//     <div class="flex_grp_between mb-3">
//         <h3 class="section_title_light mb-0">{pmsitem?.pmsitem?.metadata?.title}</h3>
//         <Link class="hyperlink" onClick={() => navigate('/recent-Transaction-Home')} >
//           {t("viewall")}
//           <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
//         </Link>
//     </div>
//     <Swiper
//       className="dashboard_swiper mb-2"
//       spaceBetween={12}
//       pagination
//       slidesPerView={1.4}
//       grid={{ rows: 1, fill: "row" }}
//       // modules={[Grid, Pagination]}
//     >
//      {srvList?.slice(0,4)?.map((item) => {
//        return (
//        <SwiperSlide>
//         <CardsComponent type={30} data={item}/>
//        </SwiperSlide>
//        );
//      })}
//    </Swiper>
//  </section>

<div class={`dls-sprint13-comp ${pmsitem?.pmsitem?.position === '15' ? 'recent_purchase_mt' : ''}`}>
<div class="flex_grp_between mb-3">
    <h3 class="section_title_light mb-0">{pmsitem?.pmsitem?.metadata?.title}</h3>
    <Link class="hyperlink" to="/recent-Transaction-Home">
      {pmsitem?.pmsitem?.metadata?.show_viewall}
      <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
    </Link>
</div>
{
  srvList?.length === 1 ?
  srvList?.map((item) => {
    return(
      <SwiperComponent
        type={22}
        data={item}
      ></SwiperComponent>
    )
  })
  :
  <Swiper
  className="dashboard_swiper dls13_card_style2"
  spaceBetween={12}
  pagination={false}
  slidesPerView={srvList?.length > 1 ? 1.5 : 1}
  // slidesPerView={srvList?.length > 3 ? 1.1 : 1}
  grid={{ rows: 1, fill: "row" }}
  // modules={[Grid, Pagination]}
>
  {
  srvList?.map((item) => {
    return (
      <SwiperSlide className="card_style_2">
        <CardsComponent type={31} data={item}/>   
      </SwiperSlide>
    );
  })}
</Swiper>
}
</div>
 
 : <></>
 
 
 } 
 </>
  );
};
export default RecentTransactionswiperComponent;
